import { clearLoginAttemptInfo, consumeCode, createCode, resendCode } from "supertokens-web-js/recipe/passwordless";
import {
    getPasswordlessLoginAttemptInfo,
  } from 'supertokens-web-js/recipe/thirdpartypasswordless';
  
  
  async function handleOTPInput(otp: string) {
    try {
        let response = await consumeCode({
            userInputCode: otp
        });
        console.log('response from consumeCode called', response);
        if (response.status === "OK") {
            // we clear the login attempt info that was added when the createCode function 
            // was called since the login was successful.
            await clearLoginAttemptInfo();
            if (response.createdNewRecipeUser && response.user.loginMethods.length === 1) {
                // user sign up success
            } else {
                // user sign in success
            }
            return 'success';
        } else if (response.status === "INCORRECT_USER_INPUT_CODE_ERROR") {
            // the user entered an invalid OTP
            window.alert("Wrong OTP! Please try again. Number of attempts left: " + (response.maximumCodeInputAttempts - response.failedCodeInputAttemptCount));
            return response;
        } else if (response.status === "EXPIRED_USER_INPUT_CODE_ERROR") {
            // it can come here if the entered OTP was correct, but has expired because
            // it was generated too long ago.
            window.alert("Old OTP entered. Please regenerate a new one and try again");
            return response;
        } else {
            // this can happen if the user tried an incorrect OTP too many times.
            // or if it was denied due to security reasons in case of automatic account linking

            // we clear the login attempt info that was added when the createCode function 
            // was called - so that if the user does a page reload, they will now see the 
            // enter email / phone UI again.
            await clearLoginAttemptInfo();
            window.alert("Login failed. Please try again");
            return response;
            window.location.assign("/")
        }
    } catch (err: any) {
        if (err.isSuperTokensGeneralError === true) {
            // this may be a custom error message sent from the API by you.
            window.alert(err.message);
        } else {
            window.alert("Oops! Something went wrong.");
        }
    }
}
  

async function handleResend() {
    try {
        let response = await resendCode();

        return response;
    } catch (err: any) {
        if (err.isSuperTokensGeneralError === true) {
            // this may be a custom error message sent from the API by you.
            return(err.message);
        } else {
            return("Oops! Something went wrong.");
        }
    }
}
  
  async function hasInitialMagicLinkBeenSent() {
    return await getPasswordlessLoginAttemptInfo() !== undefined;
  }
  

async function sendOTP(email: string) {
    try {
        let response = await createCode({
            email
        });
        /**
         * For phone number, use this:
            
            let response = await createCode({
                phoneNumber: "+1234567890"
            });
         
        */

        if (response.status === "SIGN_IN_UP_NOT_ALLOWED") {
            // the reason string is a user friendly message
            // about what went wrong. It can also contain a support code which users
            // can tell you so you know why their sign in / up was not allowed.
            console.log(response.reason)
            window.location.assign("/")
        } else {
            // OTP sent successfully.
            console.log(response)
           console.log("Please check your email for an OTP",response);
           return "success";
        }
    } catch (err: any) {
        if (err.isSuperTokensGeneralError === true) {
            // this may be a custom error message sent from the API by you,
            // or if the input email / phone number is not valid.
            console.log(err.message);
        } else {
            console.log("Oops! Something went wrong.");
        }
    }
}
  export { handleOTPInput, handleResend, hasInitialMagicLinkBeenSent, sendOTP };
  